import { createContext, type PropsWithChildren } from 'react';
import type { AppContextState } from './types';
import { initialState } from './consts';
import { getDeviceInfo } from '../../utils/device';

export const AppContext = createContext<AppContextState>(initialState);

export function AppContextProvider(props: PropsWithChildren) {
  const { children } = props;

  return (
    <AppContext.Provider
      value={{
        origin: window.location.origin,
        host: window.location.host,
        ...getDeviceInfo(),
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
